// auto-generated by Typewriter template _enums.tst from PortCall.EndPoints\Api\TopicCardChange\ApiTopicCardChange.cs
export enum TopicCardChangeType { 
    Creation = 0,
    YesNoAnswer = 1,
    TimeEntry = 2,
    Status = 3,
    SelectedOption = 4
}

export const TopicCardChangeTypeDisplayName : { [val : number] : string } = { 
    0: 'Creation',
    1: 'YesNoAnswer',
    2: 'TimeEntry',
    3: 'Status',
    4: 'SelectedOption'
}

export const TopicCardChangeTypes : { Id : TopicCardChangeType, Name : string }[] = [ 
    { Id: TopicCardChangeType.Creation, Name: 'Creation' },
    { Id: TopicCardChangeType.YesNoAnswer, Name: 'YesNoAnswer' },
    { Id: TopicCardChangeType.TimeEntry, Name: 'TimeEntry' },
    { Id: TopicCardChangeType.Status, Name: 'Status' },
    { Id: TopicCardChangeType.SelectedOption, Name: 'SelectedOption' }
]



// WEBPACK FOOTER //
// ./server/enums/TopicCardChangeType.ts